import { FuseLoadable } from '@fuse';

const Error404PageConfig = { settings: { layout: { config: {} } }, routes: [{ path: '/error-404/:itemType?', component: FuseLoadable({ loader: () => import('./Error404Page') }) }] };

export default Error404PageConfig;
